import getMultiple from "./get-multiple.js";
import getSingle from "./get-single.js";
import deleteSingle from "./delete-single.js";
import resendSingle from "./resend-single.js";

export default {
	getMultiple,
	getSingle,
	deleteSingle,
	resendSingle,
};
